import React from 'react';
import {connect} from 'react-redux';
import {change, Field} from "redux-form";

import ExpandSection from "../../Generic/expandSection";
import {toggleSectionOpened, toggleManufacturerFiltersPopup, setManufacturerFilters} from "../AccountActions";
import {loadManufacturerFilters} from "../../AddNewEntity/AddNewEntityActions";
import {ACCOUNT_SECTIONS} from "./sectionNames";
import {FormCheckBoxField, FormField} from "../FormField";
import {store} from "../../../main";
import {AccessRights} from "../../../schemas/accessRightsModel";
import SimpleDropDown from "../../PageLayout/DropDowns/SimpleDropDown/SimpleDropDown";

class FabricatorAccountSettings extends React.Component {

  state = {
    showCopied: false
  }

  copyHomeAdvisorApiEndpointUrl = (e) => {
    if (e.target.closest(".ui-input3[name='homeAdvisorApiEndpointUrl']")) {
      const ta = document.createElement('textarea');
      ta.value = this.props.homeAdvisorApiEndpointUrl;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      this.setState({showCopied: true}, () => {
        window.setTimeout(() => {
          this.setState({showCopied: false})
        }, 1500)
      });
    }
  }

  updateCheckBoxField = (input) => {
    store.dispatch(change('newEntity', input.name, !input.value))
  };

  getFabricatorTypes = () => {
    return ["STORE", "INSTALLER", "SUPPLIER", "DEALER"];
  }

  updateFabricatorType = (value) => {
    store.dispatch(change('newEntity', 'fabricatorType', value))
  }

  setManufacturerFilters = (showPopup = false) => {
    this.props.loadManufacturerFilters()
      .then((res) => {
        this.props.setManufacturerFilters({
          manufacturerFilters: res
        });
        this.props.toggleManufacturerFiltersPopup(showPopup)
      });
  }

  render() {

    const {canEditFields} = this.props.accountPageInfo;
    const {AR, fabricatorType, formValues} = this.props;
    const isAdmin = AR.isSiteAdmin(false);

    return (
      <ExpandSection opened={this.props.sectionsOpened.includes(ACCOUNT_SECTIONS.fabricator_account_settings)}
                     onClick={() => this.props.toggleSectionOpened(ACCOUNT_SECTIONS.fabricator_account_settings)}
                     title="Fabricator Account Settings">
        <div className="acc-container">
          <div className="acc-container__row">
            <div className="acc-block">
              <Field name="accountId" component={FormField} label="External Account Id" type="text"
                     disabled={!canEditFields}/>
              {isAdmin ? (
                <Field name="hideCheckoutBreakdownCost" component={FormCheckBoxField}
                       onChecked={this.updateCheckBoxField} labelEnabled="Hide Checkout Line Item Prices"
                       labelDisabled="Hide Checkout Line Item Prices"/>
              ) : null}
              {isAdmin ? (
                <Field name="showCheckoutLineItemPricesToggle" component={FormCheckBoxField}
                       // disabled={!formValues.hideCheckoutBreakdownCost}
                       onChecked={this.updateCheckBoxField} labelEnabled="Show Checkout Line Item Prices Toggle"
                       labelDisabled="Show Checkout Line Item Prices Toggle"/>
              ) : null}
              {isAdmin ? (
                <Field name="showCostPricesToggle" component={FormCheckBoxField}
                       onChecked={this.updateCheckBoxField} labelEnabled="Show Cost Prices Toggle"
                       labelDisabled="Show Cost Prices Toggle"/>
              ) : null}
              {isAdmin ? (
                <Field name="hideYourListButton" component={FormCheckBoxField}
                       onChecked={this.updateCheckBoxField} labelEnabled="Hide Look Journey Your List Button"
                       labelDisabled="Hide Look Journey Your List Button"/>
              ) : null}
              {isAdmin ? (
                <Field name="disableCustomerEmails" component={FormCheckBoxField}
                        onChecked={this.updateCheckBoxField} labelEnabled="Disable Customer Emails"
                        labelDisabled="Disable Customer Emails"/>
              ) : null }
              {isAdmin ? (
                <Field name="disableFabricatorEmails" component={FormCheckBoxField}
                        onChecked={this.updateCheckBoxField} labelEnabled="Disable Fabricator Emails"
                        labelDisabled="Disable Fabricator Emails"/>
              ) : null }
               {isAdmin ? (
                <SimpleDropDown id="fabricator-type"
                values={this.getFabricatorTypes()}
                activeValue={fabricatorType || this.getFabricatorTypes()[0]} label="Fabricator Type"
                onChange={(value) => this.updateFabricatorType(value)}/>
              ) : <p>{fabricatorType}</p> }
               {isAdmin ? (
                <div style={{marginTop: "20px"}}>
                <span className="ui-button2 ui-button2--blue"
                      onClick={() => this.setManufacturerFilters(true)}>
                  Manufacturer Filters
                </span>
              </div>
              ) : null }
            </div>
            <div className="acc-block">
              {this.props.homeAdvisorApiEndpointUrl ? (
                <div className="acc-field relative" onClick={this.copyHomeAdvisorApiEndpointUrl}>
                  <label htmlFor="homeAdvisorApiEndpointUrl" className="ui-input3-title ui-input3-title--disabled">
                    Home Advisor Lead Push Api Endpoint
                  </label>
                  <input name="homeAdvisorApiEndpointUrl" value={this.props.homeAdvisorApiEndpointUrl}
                         style={{cursor: "copy"}}
                         id="homeAdvisorApiEndpointUrl" disabled={true} className="ui-input3"/>
                  <div className={"new-account-notice" + (this.state.showCopied ? " new-account-notice--visible" : "")}>
                    Copied to Clipboard
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </ExpandSection>
    )
  }

}

const mapStateToProps = (store) => {
  const {sectionsOpened, accountPageInfo} = store.accountState;
  const {homeAdvisorApiEndpointUrl} = store.newaccount;
  return {
    sectionsOpened,
    accountPageInfo,
    AR: AccessRights.get(store),
    homeAdvisorApiEndpointUrl,
    fabricatorType: (store.form && store.form.newEntity && store.form.newEntity.values) ? store.form.newEntity.values.fabricatorType : "",
    formValues: (store.form && store.form.newEntity && store.form.newEntity.values) || {},
  };
};

const mapDispatchToProps = {
  toggleSectionOpened,
  toggleManufacturerFiltersPopup,
  loadManufacturerFilters,
  setManufacturerFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(FabricatorAccountSettings);

